// extracted by mini-css-extract-plugin
export var chip = "_2z-9";
export var chipLabel = "_2z-a";
export var close = "_2z-7";
export var closeIcon = "_2z-8";
export var error = "_2z-6";
export var infoTooltip = "_2z-2";
export var innerContainer = "_2z-1";
export var input = "_2z-b";
export var medium = "_2z-5";
export var outerContainer = "_2z-0";
export var small = "_2z-4";
export var xSmall = "_2z-3";